import ICON_TYPES from "../../../../../../src/js/misc/IconTypes";

export default (iconType, fieldBase) => {
	let field;

	switch (iconType) {
		case ICON_TYPES.DOMNODE:
			field = `${fieldBase}Dom`;
			break;

		case ICON_TYPES.FUNCTION:
			field = `${fieldBase}Function`;
			break;

		case ICON_TYPES.STRING:
			field = `${fieldBase}String`;
			break;

		case ICON_TYPES.URL:
			field = `${fieldBase}Url`;
			break;

		default:
			console.error(`iconTypeField(): Unknown header logo type: ${iconType}`);
			break;
	}
	return field;
};
